var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['gallery-root', { 'dark-mode': _vm.isDarkMode }]},[_c('main',{staticClass:"gallery-scroll"},_vm._l((_vm.galleryItems),function(item){return _c('section',{key:item.id,staticClass:"gallery-item"},[_c('img',{staticClass:"gallery-image",class:item.orientation,attrs:{"src":item.src,"alt":item.title,"loading":"lazy"}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }